import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './RadioButton.module.scss';
import { useRadio } from './useRadio';
import { RadioContext } from './useRadioContext';

export const RadioGroup = React.forwardRef((props, ref) => {
  const customProps = useRadio(props);

  const contextValues = useMemo(
    () => ({ ...props, ...customProps, radioState: props.defaultChecked }),
    [props, customProps],
  );

  const customClasses = props.customClasses;
  const styles = mergeClasses(defaultClasses, customClasses);

  return (
    <RadioContext.Provider value={contextValues}>
      <div className={styles.radiogroupWrapper}>
        <div className={styles.labelRadiogroup}>{props.label}</div>
        <div
          ref={ref}
          role="radiogroup"
          aria-labelledby="radio-group"
          className={clsx(styles.rootGroup, {
            [` ${styles.groupColumn}`]: props.layout === 'column',
            [` ${styles.groupRow}`]: props.layout === 'row',
          })}
        >
          {props.children}
        </div>
      </div>
    </RadioContext.Provider>
  );
});

RadioGroup.defaultProps = {
  value: '',
  name: '',
  onChange: () => {},
  valid: true,
};

RadioGroup.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
  renderRadio: PropTypes.func,
};
